import Icon from "app/common/Icon/index";
import useTranslation from "app/hooks/useTranslation";
import React, { useMemo } from 'react';
import { WorkOrderDetail, WorkOrderStatuses } from '~/workorder/types';
import classes from './style.module.scss';
import classNames from "classnames";
import moment from "moment";

export interface StatusMessageProps {
    status: WorkOrderDetail['status'];
    statusInfo: WorkOrderDetail['statusInfo'];
}

export type StatusMessageComponent = React.FC<StatusMessageProps>

const StatusMessage: StatusMessageComponent = ({ status, statusInfo }) => {
    const { t } = useTranslation("workorder");

    const statusClass = `status-${status}`;

    const icon = useMemo(() => {
        switch (status) {
            case WorkOrderStatuses.OPEN:
                return 'pending_actions';
            case WorkOrderStatuses.PLANNED:
                return 'calendar_today';
            case WorkOrderStatuses.DELAYED:
                return 'warning';
            case WorkOrderStatuses.INPROGRESS:
                return 'build';
            case WorkOrderStatuses.ONHOLD:
                return 'pause_circle';
            case WorkOrderStatuses.FINISHED:
                return 'done_all';
            case WorkOrderStatuses.APPROVED:
                return 'verified';
            case WorkOrderStatuses.CANCELLED:
                return 'cancel';
            case WorkOrderStatuses.NOTAPPROVED:
                return 'cancel';
            default:
                return 'check';
        }
    }, [status]);

    const commentText = useMemo(
        () => statusInfo.comment?.trim() ?? '',
        [statusInfo.comment],
    );

    const statusAtFormatted = useMemo(
        () => statusInfo?.statusAt ? moment(statusInfo.statusAt).format('DD.MM.YY HH:mm') : null,
        [statusInfo.statusAt],
    );

    const statusBy = statusInfo.statusBy?.trim() ?? '';


    return (
        <div className={classNames(classes['workorder-message'], classes[statusClass])}>
            <div className={classes['header']}>
                <Icon name={icon} className={classes['icon']}/>
                <span className={classes['title']}>{t(`statuses.${status}`)}</span>
            </div>
            {commentText ? (
                <p className={classes['comment']}>{commentText}</p>
            ) : null}
            {statusAtFormatted ? (
                <div className={classes['meta']}>
                    <span className={classes['meta-user']}>{statusBy || t('detail.system')}</span>
                    <span className={classes['meta-sep']}> • </span>
                    <span className={classes['meta-date']}>{statusAtFormatted}</span>
                </div>
            ) : null}
        </div>
    );
}

export default StatusMessage
